/* ModalSkin.js */

import React, { useCallback } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Strings from '../../translations/Translations';
import RemixSkin from '../remix/RemixSkin';

export default function ModalSkin({open, setOpen, parentSkin, setParentSkin, callback}) {
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);

  return (
    <Modal isOpen={open} toggle={toggle} size='xl'>
      <ModalHeader toggle={toggle}>
        {Strings('choose_skin')}
      </ModalHeader>
      <ModalBody>
        <RemixSkin parentSkin={parentSkin} setParentSkin={setParentSkin} callback={callback} />
      </ModalBody>
    </Modal>
  );
}
